import React from 'react'
import { object, arrayOf, array } from 'prop-types'
import withSend from 'microcosm/addons/with-send'
import cx from 'classnames'
import colors from '../../../config/colors'
import PatchLink from 'lib/components/patch-link'
import SelectedLink from 'lib/components/selected-link'
import Select from 'lib/components/select'
import Icon from 'lib/components/icon'
import RA from 'ra-config'

class SidebarAggregate extends React.PureComponent {
  static defaultProps = {
    series: []
  }

  static propTypes = {
    query: object,
    factors: arrayOf(object),
    series: array
  }

  renderCategoryIndicator(category) {
    if (category.name === 'Large') {
      return <circle fill={colors.defaultGray} r="6" cx="6" cy="6" />
    } else {
      return (
        <circle
          stroke={colors.defaultGray}
          fill="none"
          strokeWidth="2"
          r="5"
          cx="6"
          cy="6"
        />
      )
    }
  }

  renderCategory(category) {
    const { factors, query } = this.props

    const itemsForCategory = factors.filter(
      ({ Category }) => Category === category.name
    )

    const isActive = category.name === query.category
    const categoryClassName = cx({ active: isActive })

    const nextQuery = {
      category: isActive ? undefined : category.name,
      selected: undefined,
      correlationChart: isActive ? '' : category.name.toLowerCase()
    }

    return (
      <li
        key={`sidebar-category-${category.name}`}
        className={categoryClassName}
      >
        <div className="sidebar-list-category">
          <PatchLink
            query={nextQuery}
            track={category.name}
            trackAs="sidebar-category"
          >
            <svg className="sidebar-list-key">
              {this.renderCategoryIndicator(category)}
            </svg>

            <h3 className="type-title">{category.name}</h3>
          </PatchLink>

          <PatchLink
            query={{
              category: undefined,
              selected: undefined,
              correlationChart: undefined
            }}
            className="sidebar-list-close"
          >
            <Icon type="close" height="20px" width="20px" />
            <span className="screenreader-only">Clear Filter</span>
          </PatchLink>
        </div>

        <ul style={{ color: colors.defaultGray }}>
          {itemsForCategory.map(i => this.renderCategoryItem(i))}
        </ul>
      </li>
    )
  }

  renderCategoryItem(item) {
    const { series } = this.props
    const category = item.Category

    const seriesStatus = series.find(({ name }) => name === item.Name)
    const loading = seriesStatus && seriesStatus.loading ? '(Loading...)' : ''
    const track = `Factors: ${item.Name} (${category})`

    const style = {
      borderLeft: '4px solid',
      borderLeftColor: item.Color,
      color: item.Color
    }

    return (
      <li key={item.Key} data-id={item.ID} style={style}>
        <SelectedLink
          category={category}
          selected={item.Key}
          query={{ correlationChart: category.toLowerCase() }}
          track={track}
          trackAs="sidebar-item"
        >
          {item.Name} {loading}
        </SelectedLink>
      </li>
    )
  }

  render() {
    const { query } = this.props
    const { topNavigation } = RA.app.page
    const { categoryList } = RA.app.factors

    const listClassName = cx('sidebar-list sidebar-list-factors', {
      filtered: query.category != null
    })

    return (
      <aside className="sidebar">
        <div className="sidebar__main">
          <Select
            label="Select Equity Category"
            labelFor="location-filter"
            labelVisible={false}
            onChange={this.onSelectChange}
            options={topNavigation}
            selected="/factors"
            selectedText="Factors"
          />

          <ul id="sidebar-factors" className={listClassName}>
            {categoryList.map(this.renderCategory, this)}
          </ul>
        </div>
      </aside>
    )
  }

  onSelectChange = event => {
    event.target.blur()
    this.props.send('visit', event.target.value)
  }
}

export default withSend(SidebarAggregate)



// WEBPACK FOOTER //
// ./src/components/factors/aggregate/sidebar.js